<template>
    <div class="out">
        <div class="chartbox"  id="main1"  style="width:100%;height:300px"></div>
        <div class="f-row-c numbox">青海省共有{{title}}<span class="num">{{number}}</span>个</div>
    </div>
</template>

<script>
export default {
    props:['option','title'],
    inject:["reload"],
    data() {
        return {
            tit:this.title,
            number:0
        };
    },
    mounted() {
        this.getData();
    },

    methods: {
        onrest(){
            this.reload()
            this.getData()
        },
        getData(){ 
            this.number=0
            // console.log(111,this.option)
            var arrVal=[]
            if(this.option.length>0){ 
                this.option.forEach(k => {
                    arrVal.push({ 
                        value:k.orgNumber,
                        name:k.orgTypeName+":"+k.orgNumber
                    })
                    this.number+=k.orgNumber*1
                });
            }
            this.initChart1(arrVal)
            
        },
        initChart1(arrVal){
            var dome=document.getElementById('main1')
            var myChart = this.$echarts.init(dome);
            var option={
                color:['#737CC9','#7DC65A','#FEB568','#F76B52','#56CFFC','#AA0F14'],
                // title: {
                //     text: '某站点用户访问来源',
                //     subtext: '纯属虚构',
                //     left: 'center'
                // },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}({d}%)"/*鼠标经过显示*/
                },
                legend: {
                    orient: 'vertical',
                    right:'20px',
                    top:'130px'
                },
                series: [
                    {
                        name: this.title,
                        type: 'pie',
                        radius: '50%',
                        top: 0, left: 0,right:'120px', bottom: 0,
                        data:arrVal,
                        label:{            //饼图图形上的文本标签
                            normal:{
                                show:true,
                                // position:'inside', //标签的位置
                                textStyle : {
                                    fontWeight : 300 ,
                                    fontSize : 14,  //文字的字体大小
                                    // color:'#ffffff'
                                },
                                formatter:'{d}%'
                            },
                            distance:0
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                // shadowColor: 'rgba(0, 0, 0, 0.5)',
                            }
                        },
                        itemStyle:{
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                // shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                                    normal:{ 
                                label:{ 
                                    show: true, 
                                    formatter: '{b}({d}%)' 
                                }, 
                                labelLine :{show:true} 
                            } 
                        }
                    }
                ]
            }
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="scss" scoped>
.numbox{
    font-size: 16px;
    height: 54px;
    margin-right: 10px;
    line-height: 54px;
    border-top: 2px solid #ffffff;
    .num{
        color: #CB0A22;
    }
}
.out{
    width:100%;
    height: 100%;
}
</style>